export default "__VITE_ASSET__D41_rQ7D__"